"use client";

import { memo } from "react";
import WithMenu from "@/shared/ui/actions/WithMenu";
import ActionMenuPanel from "./ActionMenuPanel";

function ActionMenuDropdown() {
  return (
    <WithMenu icon="main_actions" placement="bottom" minWidth="345px">
      <ActionMenuPanel variant="mobile" />
    </WithMenu>
  );
}

export default memo(ActionMenuDropdown);
